import { Camera2D } from "../../engine/camera/Camera2D";
import { CanvasViewport } from "../../engine/canvas/CanvasViewport";
import { Region, RegionId } from "../types";
import { GeoTheme } from "./GeoTheme";

export interface GeoRenderState {
  hoveredId?: RegionId;
  selectedId?: RegionId;
  feedbackId?: RegionId;
  feedbackKind?: "correct" | "incorrect";
  showLabels?: boolean;
}

export class GeoRenderer {
  draw(
    ctx: CanvasRenderingContext2D,
    viewport: CanvasViewport,
    camera: Camera2D,
    theme: GeoTheme,
    regions: Region[],
    state: GeoRenderState,
  ): void {
    const { width, height } = viewport.size;

    ctx.save();
    viewport.applyToContext(ctx);
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = theme.background;
    ctx.fillRect(0, 0, width, height);

    ctx.save();
    camera.apply(ctx);
    ctx.lineWidth = theme.strokeWidth / camera.zoom;

    ctx.fillStyle = theme.regionFill;
    for (const region of regions) {
      ctx.fill(region.path);
    }

    ctx.strokeStyle = theme.regionStroke;
    for (const region of regions) {
      ctx.stroke(region.path);
    }

    if (state.hoveredId) {
      const hovered = regions.find((r) => r.id === state.hoveredId);
      if (hovered) {
        ctx.fillStyle = theme.hoverFill;
        ctx.fill(hovered.path);
      }
    }

    if (state.selectedId) {
      const selected = regions.find((r) => r.id === state.selectedId);
      if (selected) {
        ctx.fillStyle = theme.selectedFill;
        ctx.fill(selected.path);
      }
    }

    if (state.feedbackId) {
      const feedback = regions.find((r) => r.id === state.feedbackId);
      if (feedback) {
        ctx.fillStyle =
          state.feedbackKind === "incorrect"
            ? theme.incorrectFill
            : theme.correctFill;
        ctx.fill(feedback.path);
      }
    }

    if (state.showLabels && camera.zoom > theme.labelZoomThreshold) {
      ctx.fillStyle = theme.labelColor;
      ctx.font = theme.labelFont;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      for (const region of regions) {
        ctx.fillText(
          region.props.plName,
          region.centroid[0],
          region.centroid[1],
        );
      }
    }

    ctx.restore();
    ctx.restore();
  }
}
